import { useEffect } from "react";

/**
 * disables the page scroll on mount. Re-enables it on un-mount
 *
 * ### applies:
 * ```css
 *  // on mount
 *  body {
 *    overflow: hidden;
 *  }
 *
 *  // on un-mount
 *  body {
 *    overflow: auto;
 *  }
 * ```
 */
export default function useDisableScroll() {
  // Effect to disable body scrolling when component is mounted
  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);
}
